import React from 'react';
import { FaBoxOpen, FaClipboardList, FaSignOutAlt, FaStore, FaUser } from 'react-icons/fa';
import { useDispatch } from 'react-redux';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import {logout, } from "../../../redux/slices/authSlice";
import {clearCart} from "../../../redux/slices/cartSlice";
import {User, Shirt, Package, Store, LogOut, Undo2, MessageSquare, Tag} from "lucide-react";

const AdminSidebar = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const handleLogout = () => {
        dispatch(logout());
        dispatch(clearCart());
        navigate("/");
    };



  return (
    <div className="p-6">
        <div className="mb-6 text-center">
            <Link to="/admin" className="text-2xl font-medium">
                
            <img 
                src="https://res.cloudinary.com/dmrlotfsv/image/upload/v1754111081/VESHH-EON_TYPE_WHITE_f3gm0u.png" />
            
            </Link>
        </div>
        <h2 className="text-xll font-medium mb-6 text-center">Admin Dashboard</h2>
        <nav className="flex flex-col space-y-2">

            <NavLink to="/admin" className={({isActive}) => isActive ? "bg-gray-700 text-white py-3 px-4 rounded flex items-center space-x-2" : "text-gray-300 hover:bg-gray-700 hover: text-white py-3 px-4 rounded flex items-center space-x-2"}>
            <Store/>
            <span>Overview</span>
            </NavLink>

            <NavLink to="/admin/orders" className={({isActive}) => isActive ? "bg-gray-700 text-white py-3 px-4 rounded flex items-center space-x-2" : "text-gray-300 hover:bg-gray-700 hover: text-white py-3 px-4 rounded flex items-center space-x-2"}>
            <Package/>
            <span>Orders</span>
            </NavLink>

            <NavLink to="/admin/returns" className={({isActive}) => isActive ? "bg-gray-700 text-white py-3 px-4 rounded flex items-center space-x-2" : "text-gray-300 hover:bg-gray-700 hover: text-white py-3 px-4 rounded flex items-center space-x-2"}>
            <Undo2 />
            <span>Returns</span>
            </NavLink>

            
            <NavLink to="/admin/users" className={({isActive}) => isActive ? "bg-gray-700 text-white py-3 px-4 rounded flex items-center space-x-2" : "text-gray-300 hover:bg-gray-700 hover: text-white py-3 px-4 rounded flex items-center space-x-2"}>
            <User/>
            <span>Users</span>
            </NavLink>

            <NavLink to="/admin/products" className={({isActive}) => isActive ? "bg-gray-700 text-white py-3 px-4 rounded flex items-center space-x-2" : "text-gray-300 hover:bg-gray-700 hover: text-white py-3 px-4 rounded flex items-center space-x-2"}>
            <Shirt/>
            <span>Products</span>
            </NavLink>

            <NavLink to="/admin/messages" className={({isActive}) => isActive ? "bg-gray-700 text-white py-3 px-4 rounded flex items-center space-x-2" : "text-gray-300 hover:bg-gray-700 hover: text-white py-3 px-4 rounded flex items-center space-x-2"}>
            <MessageSquare/>
            <span>Messages</span>
            </NavLink>

            <NavLink to="/admin/offers" className={({isActive}) => isActive ? "bg-gray-700 text-white py-3 px-4 rounded flex items-center space-x-2" : "text-gray-300 hover:bg-gray-700 hover: text-white py-3 px-4 rounded flex items-center space-x-2"}>
            <Tag/>
            <span>Offers</span>
            </NavLink>












            <div className="mt-6">
                <button onClick={handleLogout} className="w-full bg-red-500 hover:bg-red-600 text-white py-2 px-4 rounded flex items-center justify-center space-x-2">
                    <LogOut />
                    <span>Logout</span>
                </button>
            </div>
        </nav>
    </div>
  )
}

export default AdminSidebar;
